import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { UsersList } from './admin/UsersList';
import { useOrg } from './useOrg';
import { useOrganizationRole } from './useOrganizationRole';
import { useCreateInvite } from './useOrganizations';

export function OrganizationUsersPage() {
  const { selectedOrg } = useOrg();
  const [email, setEmail] = useState('');
  const [inviteLink, setInviteLink] = useState<string | null>(null);

  const orgId = selectedOrg?.id;
  const roleQuery = useOrganizationRole(orgId);
  const inviteMutation = useCreateInvite(orgId ?? undefined);

  if (roleQuery.isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        Loading...
      </Box>
    );
  }

  if (!roleQuery.data?.isAdmin) {
    return (
      <Container maxWidth={'sm'} sx={{ mt: 4 }}>
        <Alert severity={'error'}>
          You do not have permission to manage users for this organization.
        </Alert>
      </Container>
    );
  }

  const handleInvite = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    void inviteMutation
      .mutateAsync({ email })
      .then((result) => {
        const code = result.code;
        const url = `${window.location.origin}/#/signup/${code}`;
        setInviteLink(url);
        setEmail('');
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <Container maxWidth={'md'} sx={{ mt: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant={'h4'} gutterBottom>
          User Management
        </Typography>
        <Typography variant={'body1'} color={'text.secondary'} sx={{ mb: 4 }}>
          Manage users for {selectedOrg!.name}
        </Typography>

        <Box
          component={'form'}
          onSubmit={handleInvite}
          sx={{ display: 'flex', gap: 2, mb: 3 }}
        >
          <TextField
            label={'Invite Email'}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            size={'small'}
          />
          <Button
            type={'submit'}
            variant={'contained'}
            disabled={inviteMutation.isPending}
          >
            Invite
          </Button>
        </Box>

        {inviteLink && (
          <Alert severity={'success'} sx={{ mb: 3 }}>
            Invitation link: <a href={inviteLink}>{inviteLink}</a>
          </Alert>
        )}

        <UsersList organizationId={selectedOrg!.id} />
      </Paper>
    </Container>
  );
}
